import { Modal } from "react-bootstrap";
import "./ImageModal.scss";
interface ImageModalPropsI {
	show: boolean;
	onHide: () => void;
	imageUrl: string;
}
function ImageModal(props: ImageModalPropsI) {
	const { show, onHide, imageUrl } = props;
	return (
		<Modal
			className="base-modal image-modal"
			show={show}
			onHide={onHide}
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body>
				<img src={imageUrl} alt="full view" />
			</Modal.Body>
		</Modal>
	);
}

export default ImageModal;
